import theme from "@shared/utils/themeColors";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../features/auth/hooks/useAuth";
import { useAuthStore } from "../features/auth/store/authStore";
import { useOnClickOutside } from "../hooks/useOnClickOutside";

function DropdownProfile() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { logout } = useAuth();
  const { user } = useAuthStore();
  const trigger = useRef(null);
  const dropdown = useRef(null);

  // Close on click outside
  useOnClickOutside(dropdown, () => setDropdownOpen(false));

  // Close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  if (!user) return null;

  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="inline-flex justify-center items-center group"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <img
          className="w-8 h-8 rounded-full"
          src={
            user.profile?.avatar ||
            `https://ui-avatars.com/api/?name=${
              user.profile?.name || user.email
            }`
          }
          alt="User"
        />
        <div className="flex items-center truncate">
          <span className="truncate ml-2 text-sm font-medium dark:text-gray-300 group-hover:text-gray-800 dark:group-hover:text-gray-200">
            {user.profile?.name || user.email?.split("@")[0]}
          </span>
          <svg
            className="w-3 h-3 shrink-0 ml-1 fill-current text-gray-400"
            viewBox="0 0 12 12"
          >
            <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
          </svg>
        </div>
      </button>

      <div
        ref={dropdown}
        className={`origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 py-1.5 rounded shadow-lg overflow-hidden mt-1 ${
          dropdownOpen ? "block" : "hidden"
        }`}
      >
        <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-gray-200 dark:border-gray-700">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            {user.profile?.name}
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400 italic">
            {user.email}
          </div>
        </div>
        <ul>
          <li>
            <Link
              className={`font-medium text-sm ${theme.text.link} flex items-center py-1 px-3`}
              to="/settings/account"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              Settings
            </Link>
          </li>
          <li>
            <button
              onClick={logout}
              className={`font-medium text-sm ${theme.text.link} flex items-center py-1 px-3`}
            >
              Sign Out
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default DropdownProfile;
